import React, { Fragment, useCallback } from "react";
import { isMobile } from "react-device-detect";
import { Trans } from "react-i18next";
import classNames from "classnames";
import { JAVASCRIPT_VOID } from "constant/config";
import { setClickLogapi } from "helpers";

import { LAYER } from "components/boards/post/catchstory/layer/CatchStoryHiddenLayer";
import CatchStoryHiddenImage from "components/boards/post/catchstory/layer/CatchStoryHiddenImage";

const CatchStoryHiddenConfirmLayer = ({ vod, onChangeLayer, storyHiddenInfo, close, closeLayer }) => {

	// 삭제하기 버튼 클릭 시 캐치 스토리 삭제 사유 레이어로 이동
	const handleChangeLayer = useCallback(
		(layer) => () => {
            setClickLogapi("story_separate_delete_popup1", {contents_type : "catch_story", action : "click", button_type : "to_delete"});
			setClickLogapi("story_separate_delete_popup2", {contents_type : "catch_story", action : "view", button_type : ""});
			onChangeLayer(layer);
		},
		[onChangeLayer],
	);

    // 1차 삭제 방어 팝업 아니오 버튼
    const handleDeletePopupClick = () => {
        setClickLogapi("story_separate_delete_popup1", {contents_type : "catch_story", action : "click", button_type : "to_exit_btn"});
        close(closeLayer);
    }

	// PC 1차 삭제 방어 팝업 닫기 아이콘
    const handleDeleteIconPopupClick = () => {
        setClickLogapi("story_separate_delete_popup1", {contents_type : "catch_story", action : "click", button_type : "to_exit_icon"});
        close(closeLayer);
    }

    const aVodBroadDate = vod.broad_date.split("-");
    const year = aVodBroadDate[0];
    const month = aVodBroadDate[1];
    const day = aVodBroadDate[2];

	const catchCnt = storyHiddenInfo.catch_cnt;
	const readCnt = storyHiddenInfo.read_cnt;
	const copyrighterNick = storyHiddenInfo.copyrighter_nick;

	return (
		<Fragment>
			{!isMobile && (
				<button type="button" className="close" onClick={handleDeleteIconPopupClick}><span>레이어 닫기</span></button>
			)}
			{/* 팝업 제목 */}
            <p className="pop-title">
				{isMobile ? (
					<>
						<Trans copyrighterNick={copyrighterNick} year={year} month={month} day={day}><span className="nick">{{copyrighterNick}}</span>님의<br/><em className="story_date"> {{year}}년 {{month}}월 {{day}}일</em> 스토리</Trans>
					</>
				) : (
					<>
						<Trans copyrighterNick={copyrighterNick} year={year} month={month} day={day}><span className="nick">{{copyrighterNick}}</span>님의<em className="story_date"> {{year}}년 {{month}}월 {{day}}일</em> 스토리</Trans>
					</>
				)}
				
            </p>

			<div className={classNames("pop-body")}>
				<CatchStoryHiddenImage vod={vod.ucc} storyHiddenInfo={storyHiddenInfo} />
				<div className="txt_box">
					{isMobile ? (
						<>
							<p className="txt_memory">
								<Trans catchCnt={catchCnt}>해당 스토리에는 팬들과 함께한<br/><em>{{catchCnt}}</em>개의 추억이 담겨있습니다.</Trans>
							</p>
						</>
					) : (
						<>
							<ul className="txt_memory">
								<li><Trans readCnt={readCnt}>이 스토리는 <em>{{readCnt}}</em>명이 참여했습니다.</Trans></li>
								<li><Trans catchCnt={catchCnt}>팬들과 함께한 <em>{{catchCnt}}</em>개의 추억이 담겨있습니다.</Trans></li>
							</ul>
						</>
					)}
					<p className="txt_delete">
						<Trans>그래도 이 스토리를 삭제하시겠습니까?</Trans>
					</p>
				</div>
            </div>

			{/* 버튼 영역 */}
			<div className="pop-btn">
				{isMobile && (
					<Fragment>
						<a href={JAVASCRIPT_VOID} className="btn" onClick={handleDeletePopupClick}>
							<Trans>아니요</Trans>
						</a>

						<button type="button" className="btn" onClick={handleChangeLayer(LAYER.REASON)}>
							<strong>
								<Trans>네, 삭제 할래요</Trans>
							</strong>
						</button>
					</Fragment>
				)}
				{!isMobile && (
					<Fragment>
						<button type="button" className="btn" onClick={handleChangeLayer(LAYER.REASON)}>
							<strong>
								<Trans>네, 삭제 할래요</Trans>
							</strong>
						</button>

						<a href={JAVASCRIPT_VOID} className="btn" onClick={handleDeletePopupClick}>
							<Trans>아니요</Trans>
						</a>
					</Fragment>
				)}
			</div>
		</Fragment>
	);
};

export default CatchStoryHiddenConfirmLayer;
